import { Base64 } from 'js-base64';

export default function decodeBase64Unicode(text: string): string {
  try {
    return Base64.decode(text);
  } catch {
    return '';
  }
}
